module.exports = __webpack_public_path__ + "media/images/icons/facebook-450a97521959f76d5b5da6fd06165fbf.svg";